import { h, JSX, FunctionalComponent } from "preact";
import { Icon } from "@uw/icons/types";
const defaultStyle = {
  width: "24px",
  height: "24px",
  display: "flex",
};
const SvgIcon = (props: JSX.SVGAttributes<any>) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 14 10" {...props}>
    <g fill="none" fill-rule="evenodd" stroke="currentColor">
      <path
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-width={1.25}
        d="m1 5 2.204-2.571a5 5 0 0 1 7.592 0L13 5h0l-2.204 2.571a5 5 0 0 1-7.592 0L1 5h0Z"
      />
      <path
        stroke-width={1.75}
        d="M7 3.375c.449 0 .855.182 1.149.476.294.294.476.7.476 1.149 0 .449-.182.855-.476 1.149A1.62 1.62 0 0 1 7 6.625a1.62 1.62 0 0 1-1.149-.476A1.62 1.62 0 0 1 5.375 5c0-.449.182-.855.476-1.149A1.62 1.62 0 0 1 7 3.375Z"
      />
    </g>
  </svg>
);
export const VisuallyImpairedIcon: FunctionalComponent<Icon> = ({
  className,
  svgAttrs = {
    width: "100%",
    height: "100%",
  },
  key,
  jsx,
  children,
  ref,
  ...styles
}) => (
  <span
    className={className}
    style={{
      ...defaultStyle,
      ...styles,
    }}
  >
    <SvgIcon {...svgAttrs} />
  </span>
);
